import {z as zod} from "zod";

export type TuffexProductInventoryWorkspaceCapabilityConfiguration = Record<string, never>;

export const tuffexProductInventoryWorkspaceCapabilityConfigurationValidator: zod.ZodType<TuffexProductInventoryWorkspaceCapabilityConfiguration> = zod.strictObject({});
